// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ce95c96a","239":"c343489b","453":"452c40f6","455":"81a3679c"}[chunkId] + ".chunk.js";
};